<template>
    <div class="w-full">

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
                <div class="grid grid-cols-12 gap-4">
                    <AppModal v-model="showViewReversalHistory" size="lg" title="View de-registration reversal history" hide-footer>
                        <div class="col-span-11 mx-auto">
                            <div class="grid grid-cols-12 gap-4">
                                <div class="col-span-12">
                                    <table class="table  table-striped">
                                        <thead>
                                        </thead>
                                        <tbody class="table-striped">
                                        <tr>
                                            <td>Name</td>
                                            <td>{{ reversalHistory.companyName }}</td>
                                        </tr>
                                        <tr>
                                            <td>Date added</td>
                                            <td>{{ reversalHistory.createdAt }}</td>
                                        </tr>
                                        <tr>
                                            <td>Date updated</td>
                                            <td>{{ reversalHistory.updatedAt }}</td>
                                        </tr>
                                        <tr>
                                            <td>Added by</td>
                                            <td>{{ reversalHistory.addedBy }}</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <table class="table border">
                                        <thead>
                                        <tr>
                                            <td colspan="4">Historical changes</td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(rev,idx) in reversalHistory.history" :key="idx">
                                            <td>
                                                {{ rev.createdAt }}
                                            </td>
                                            <td>
                                                <div v-if="rev.fromStatus ==='OFF'">
                                                    <i class="fa fa-arrow-left text-green"></i>
                                                    Removed from black list
                                                </div>
                                                <div v-else>
                                                    <i class="fa fa-arrow-right text-red"></i>
                                                    Added to black list
                                                </div>
                                            </td>
                                            <td>
                                                {{ rev.addedBy }}
                                            </td>
                                            <td>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </AppModal>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 mx-3 mt-3">
                <span class="title">De-Registration  Registry</span>
            </div>
            <div class="col-span-12">
                <div class="grid grid-cols-12 gap-4">
                    <AppModal v-model="showStrikeCompanyModal" size="lg" title="Add companies  to be de-registered"
                             hide-footer>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 mx-auto mb-2">
                                <div class="border-b border-gray-200">
                                    <nav class="flex space-x-6 px-4" aria-label="Tabs">
                                    <div :class="[(option === 'form') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
                                         @click="select('form')">
                                        <div class="flex mt-6">
                                            <div style="font-size: 14px" class="mt-1">Upload File</div>
                                        </div>
                                    </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-8 mx-auto">
                                <form @submit.prevent="saveUpload" v-if="option === 'form'">
                                    <div class="flex gap-2">
                                        <input type="file" @change="handleFileChange" accept=".csv, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="block w-full text-sm text-gray-600 file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-white hover:file:bg-primary-600 file:cursor-pointer border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary" />
                                    </div>
                                    <button class="btn-primary bg-primary text-white px-3 py-1 rounded-sm mt-2 float-end"
                                            type="submit">
                                        Upload
                                        <span class="lds-ring" v-if="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </AppModal>
                    <AppModal v-model="showBulkRemoveModal" size="lg" title="Remove companies from de-registered list"
                             hide-footer>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-8 mx-auto">
                                <form @submit.prevent="saveBulkRemove">
                                    <input type="file" @change="handleRemoveFileChange" accept=".csv, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" class="block w-full text-sm text-gray-600 file:mr-2 file:py-2 file:px-3 file:rounded file:border-0 file:text-sm file:font-medium file:bg-primary file:text-white hover:file:bg-primary-600 file:cursor-pointer border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary" />
                                    <button class="btn-primary bg-primary text-white px-3 py-1 rounded-sm mt-2 float-end"
                                            type="submit" :disabled="removeSpinner">
                                        Remove
                                        <span class="lds-ring" v-if="removeSpinner">
                                            <div></div><div></div><div></div><div></div>
                                        </span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </AppModal>
                </div>
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-8"></div><div class="col-span-2"><button class="btn-primary w-full bg-red text-white px-2 py-1 rounded-sm text-sm" @click="openRemoveForm"><i class="fa fa-minus"></i> Bulk Remove</button></div>
                            <div class="col-span-2">
                                <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-sm text-sm"
                                        @click="openForm"><i
                                        class="fa fa-plus"></i>
                                    De-register Company
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 my-2">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-2">
                        <input
                            type="text"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-gray text-sm noFocus ml-1"
                            style="margin-top: 1px; padding:6px 5px;"
                            v-model="search"
                            placeholder="Search by Name or BRN"
                            required
                            @keyup.enter="fetch">
                        </input>
                    </div>

                    <div class="col-span-2">
                        <select v-model="status" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                            <option :value="null">--Filter by Status--</option>
                            <option value="Registered">Registered</option>
                            <option value="Insolvent">Insolvent</option>
                            <option value="Ceased">Ceased</option>
                        </select>
                    </div>
                    <div class="col-span-3"></div>
                    <div class="col-span-1">
                        <select v-model="limit" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-span-2">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 mx-auto">
                                <p class="paginate-details text-center text-xs font-bold">
                                    <span>{{ ((currentPage - 1) * limit) + 1 }}</span> -
                                    <span v-if="limit > entities.length ">{{ pagination.totalElements }}</span>
                                    <span v-else>{{ currentPage * limit }}</span>
                                    of {{ pagination.totalElements }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mx-auto">
            <span class="lds-ring" v-if="loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </span>
        </div>

        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
                <table class="min-w-full leading-normal">
                    <thead>
                    <tr class="border-b border-t border-gray-200">
                        <th class="t-header">#</th>
                        <th class="t-header">BRN</th>
                        <th class="t-header">Name</th>
                        <th class="t-header text-center">Date</th>
                        <th class="t-header text-center">Added By</th>
                        <th class="t-header text-center">Action</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(entity, idx) in entities" :key="idx">
                        <td class="t-body">{{ (currentPage - 1) * limit + idx + 1 }}</td>
                        <td class="t-body text-primary font-bold">
                            <span class="hover:text-primary-dark cursor-pointer underline"
                                  @click="viewFile(entity.brn)">{{ entity.brn }}</span>
                        </td>

                        <td class="t-body text-black font-bold">
                            <span class="hover:text-primary-dark cursor-pointer underline"
                                  @click="viewFile(entity.brn)">{{ entity.companyName }}</span>
                        </td>


                        <td class="t-body text-center">
                            {{ dateFormat(entity.createdAt) }}
                        </td>
                        <td class="t-body text-center">
                <span class="px-1 py-1 text-green text-xs">
                  {{ entity.addedBy }}
                </span>
                        </td>
                        <td class="text-center">
                            <button class="btn-primary bg-primary text-white mx-2 rounded p-2 text-xs hover:bg-primary-dark"
                                    @click="getReversalHistory(entity.brn)">
                                <i class="fa fa-eye text-white mr-2"></i>History
                            </button>
                            <button class="btn-primary bg-red text-white rounded-sm px-2 py-1 text-xs hover:bg-red-dark"
                                    @click="reverseBlackList(entity.brn)">Reverse
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td v-if="entities.length === 0" colspan="8" class="bg-inertgrey text-center py-1">
                            <span class="text-sm">No results found</span>
                        </td>
                    </tr>
                    <tr>
                        <td v-if="hasError" colspan="12" class="bg-red text-center py-1 text-white">
                            <p class="text-sm">Failed to load tasks, Try again later.</p>
                            <p class="text-sm">{{ errorMessage }}</p>
                            <p class="text-sm">
                                <button class="btn-primary bg-white text-red px-2 rounded-sm" @click="fetch">Reload
                                    <span class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
                                </button>
                            </p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-4 mx-1" v-if="pagination.totalPages> 1">
            <div class="col-span-1">
                <button class="btn-primary" @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
            </div>
            <div class="col-span-1">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                        <p class="paginate-details text-center">
                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-white">
                                {{ (currentPage) }}/{{ pagination.totalPages }}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-span-1">
                <button @click="next" class="btn-primary" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">
                    Next
                </button>
            </div>
            <div class="col-span-6"></div>
            <div class="col-span-1">
                <select v-model="limit" class="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div class="col-span-2">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 mx-auto">
                        <p class="paginate-details text-center text-xs font-bold">
                            <span>{{ ((currentPage - 1) * limit) + 1 }}</span> -
                            <span v-if="limit > entities.length ">{{ pagination.totalElements }}</span>
                            <span v-else>{{ currentPage * limit }}</span>
                            of {{ pagination.totalElements }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AppModal from "@/components/ui/AppModal.vue";
import { dateFormat } from "@/commons/composables/utilities";
import { api } from "@/app/services/api.service";
import { useToast } from "@/composables";

interface Entity {
    brn: string
    companyName: string
    createdAt: string
    addedBy: string
}

interface Pagination {
    totalElements: number
    totalPages: number
}

interface Form {
    file: File | null
    brn: string | null
}

interface HistoryItem {
    createdAt: string
    fromStatus: string
    addedBy: string
}

interface ReversalHistory {
    brn: string | null
    companyName: string
    createdAt: string
    updatedAt: string
    addedBy: string
    lastStatusUpdateDoneBy: string
    history: HistoryItem[]
}

const router = useRouter()
const { successToast, errorToast, warningToast } = useToast()

const showViewReversalHistory = ref(false)
const showStrikeCompanyModal = ref(false)
const loading = ref(false)
const currentPage = ref(1)
const limit = ref(15)
const entities = ref<Entity[]>([])
const pagination = ref<Pagination>({
    totalElements: 0,
    totalPages: 0
})
const rows = ref({
    odd: "border-t border-gray-200 hover:bg-gray-10",
    even: "border-t border-gray-200 bg-gray-10"
})
const search = ref("")
const status = ref<string | null>(null)
const hasError = ref(false)
const errorMessage = ref<string | null>(null)
const reversalHistory = ref<ReversalHistory>({
    brn: null,
    companyName: "",
    createdAt: "",
    updatedAt: "",
    addedBy: "",
    lastStatusUpdateDoneBy: "null",
    history: []
})
const form = ref<Form>({
    file: null,
    brn: null
})
const option = ref("form")
const spinner = ref(false)
const showBulkRemoveModal = ref(false)
const removeFile = ref<File | null>(null)
const removeSpinner = ref(false)

onMounted(() => {
    fetch()
})

const fetch = () => {
    let data = {
        search: search.value,
        page: currentPage.value,
        limit: limit.value,
        offset: limit.value,
        status: "ON"
    }
    loading.value = true
    fetchDeregistration(data)
}

const select = (route: string) => {
    option.value = route
}

const handleFileChange = (e: Event) => {
    const target = e.target as HTMLInputElement
    const file = target.files?.[0]
    if (file) {
        form.value.file = file
    }
}

const saveUpload = () => {
    let formData = new FormData()
    if (form.value.file) {
        formData.set("file", form.value.file)
    }
    spinner.value = true
    uploadBatchBrnsForDeregistry(formData)
}

const uploadBatchBrnsForDeregistry = async (data: FormData) => {
    await api()
        .post("/data-update/de-registrations/import/csv", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(() => {
            successToast("Success", "Data uploaded successfully")
            fetch()
            spinner.value = false
        })
        .catch(error => {
            errorToast("Error", error.response?.data?.message || "Failed to upload data")
            spinner.value = false
        })
}

const next = () => {
    if (currentPage.value < pagination.value.totalPages) {
        currentPage.value++
        fetch()
    }
}

const previous = () => {
    if (currentPage.value > 1) {
        currentPage.value--
        fetch()
    } else {
        warningToast("Observation", "No more data to show")
    }
}

const viewFile = (brn: string) => {
    localStorage.setItem("entityType", "building-society")
    router.push("/home/non-individuals/file-viewer/" + brn)
    router.go(0)
}

const reverseBlackList = (brn: string) => {
    loading.value = true
    removeFromBlackListRegistry(brn)
}

const removeFromBlackListRegistry = async (brn: string) => {
    await api()
        .post("/data-update/de-registrations/" + brn, brn)
        .then(() => {
            successToast("Success", "Removed from  the de-registered list")
            fetch()
        })
        .catch(error => {
            errorToast("Error", error.response?.data?.message || "Failed to remove from de-registered list")
        })
}

const getReversalHistory = async (brn: string) => {
    await api()
        .get("/data-update/de-registrations/" + brn)
        .then(response => {
            reversalHistory.value = response.data.data
            showViewReversalHistory.value = true
        })
        .catch(error => {
            errorToast("Error", error.response?.data?.message || "Failed to load reversal history")
        })
}

const fetchDeregistration = async (data: any) => {
    await api()
        .get("/data-update/de-registrations?page=" + data.page + "&pageSize=" + data.limit + "&status=" + data.status + "&search=" + data.search)
        .then((response) => {
            entities.value = response.data.content
            pagination.value.totalPages = response.data.totalPages
            pagination.value.totalElements = response.data.totalElements
        })
        .catch(() => {
            errorToast("Error", "Failed to load non-individuals data")
        })
        .finally(() => {
            loading.value = false
        })
}


const openForm = () => {
    showStrikeCompanyModal.value = true
}

const openRemoveForm = () => {
    removeFile.value = null
    showBulkRemoveModal.value = true
}

const handleRemoveFileChange = (e: Event) => {
    const target = e.target as HTMLInputElement
    removeFile.value = target.files?.[0] ?? null
}

const saveBulkRemove = async () => {
    if (!removeFile.value) {
        warningToast("Observation", "Please select a file to upload")
        return
    }
    const formData = new FormData()
    formData.set("file", removeFile.value)
    removeSpinner.value = true
    await api()
        .post("/data-update/de-registrations/remove/csv", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(() => {
            successToast("Success", "Companies removed from the de-registered list")
            showBulkRemoveModal.value = false
            removeFile.value = null
            fetch()
        })
        .catch(error => {
            errorToast("Error", error.response?.data?.message || "Failed to remove companies")
        })
        .finally(() => {
            removeSpinner.value = false
        })
}
</script>
